// Policy text supplied by DeenLit (Privacy Policy and Terms and Conditions documents). Edit the wording here.
export const LEGAL_DOCS = {
 "privacy": {
  "title": "Privacy Policy",
  "updated": "4 September 2026",
  "blocks": [
   [
    "p",
    "At DeenLit, we take your privacy seriously, especially the privacy of children who use our platform."
   ],
   [
    "p",
    "This Privacy Policy explains what personal information we collect, why we collect it, how we use and protect it, and the rights available to you."
   ],
   [
    "p",
    "DeenLit is an educational reading platform designed to help children and families access books, quizzes and other learning content."
   ],
   [
    "p",
    "The data controller responsible for your personal information is:"
   ],
   [
    "p",
    "DeenLit\nLegal entity: StreamBooks Ltd\nAddress:14/2E Docklands Business Centre\n10–16 Tiller Road\nLondon\nE14 8PX\nUnited Kingdom"
   ],
   [
    "p",
    "Email: support@deenlit.com"
   ],
   [
    "h",
    "1. Information We Collect"
   ],
   [
    "p",
    "The information we collect depends on how you use DeenLit."
   ],
   [
    "h",
    "Account information"
   ],
   [
    "p",
    "When a parent, guardian or other user creates an account, we may collect information such as:"
   ],
   [
    "li",
    "name;"
   ],
   [
    "li",
    "email address;"
   ],
   [
    "li",
    "account login information;"
   ],
   [
    "li",
    "subscription or membership information;"
   ],
   [
    "li",
    "account preferences; and"
   ],
   [
    "li",
    "communications you send to us."
   ],
   [
    "p",
    "Passwords are not stored by us in readable form and should be securely encrypted or hashed by the authentication system used by DeenLit."
   ],
   [
    "h",
    "Child profile information"
   ],
   [
    "p",
    "A parent or guardian may be able to create one or more profiles for children using their account."
   ],
   [
    "p",
    "Depending on the features being used, a child profile may contain:"
   ],
   [
    "li",
    "profile name or nickname;"
   ],
   [
    "li",
    "profile image or avatar;"
   ],
   [
    "li",
    "age or age range, if provided;"
   ],
   [
    "li",
    "preferred language;"
   ],
   [
    "li",
    "reading history;"
   ],
   [
    "li",
    "books opened or completed;"
   ],
   [
    "li",
    "reading progress;"
   ],
   [
    "li",
    "quiz attempts and results;"
   ],
   [
    "li",
    "achievements or reward points, such as Noor Points;"
   ],
   [
    "li",
    "favourites;"
   ],
   [
    "li",
    "playlists or reading lists; and"
   ],
   [
    "li",
    "other learning progress associated with the profile."
   ],
   [
    "p",
    "We encourage parents not to enter unnecessary personal information about a child."
   ],
   [
    "h",
    "Technical information"
   ],
   [
    "p",
    "When DeenLit is accessed, we may automatically receive limited technical information such as:"
   ],
   [
    "li",
    "IP address;"
   ],
   [
    "li",
    "browser type;"
   ],
   [
    "li",
    "operating system;"
   ],
   [
    "li",
    "device type;"
   ],
   [
    "li",
    "approximate country or region;"
   ],
   [
    "li",
    "date and time of access;"
   ],
   [
    "li",
    "pages or features used;"
   ],
   [
    "li",
    "error and diagnostic information; and"
   ],
   [
    "li",
    "security logs."
   ],
   [
    "p",
    "We use this information primarily to operate, secure and improve DeenLit."
   ],
   [
    "h",
    "Payment information"
   ],
   [
    "p",
    "If DeenLit offers paid subscriptions or purchases, payments may be processed by a third-party payment provider."
   ],
   [
    "p",
    "DeenLit does not need to store your full debit or credit card details where payment information is handled directly by the payment provider."
   ],
   [
    "p",
    "We may receive information relating to the transaction, such as:"
   ],
   [
    "li",
    "payment status;"
   ],
   [
    "li",
    "subscription type;"
   ],
   [
    "li",
    "transaction reference;"
   ],
   [
    "li",
    "amount paid; and"
   ],
   [
    "li",
    "billing or payment-related account information."
   ],
   [
    "h",
    "Communications"
   ],
   [
    "p",
    "If you contact us for help, make a complaint or send us feedback, we may keep a record of the communication and the information you provide."
   ],
   [
    "h",
    "2. Information We Do Not Intentionally Collect"
   ],
   [
    "p",
    "DeenLit does not intend to collect sensitive personal information from children unless it is genuinely necessary for a particular service."
   ],
   [
    "p",
    "In particular, children should not provide information about matters such as:"
   ],
   [
    "li",
    "health or medical conditions;"
   ],
   [
    "li",
    "precise home addresses;"
   ],
   [
    "li",
    "passwords;"
   ],
   [
    "li",
    "financial information; or"
   ],
   [
    "li",
    "other private or sensitive information"
   ],
   [
    "p",
    "through profile names, feedback forms or other areas of DeenLit."
   ],
   [
    "p",
    "If we discover that unnecessary sensitive information has been submitted, we may remove it."
   ],
   [
    "h",
    "3. How We Use Personal Information"
   ],
   [
    "p",
    "We may use personal information to:"
   ],
   [
    "li",
    "create and maintain accounts and profiles;"
   ],
   [
    "li",
    "provide access to DeenLit;"
   ],
   [
    "li",
    "remember reading progress;"
   ],
   [
    "li",
    "record quiz results and achievements;"
   ],
   [
    "li",
    "manage favourites and playlists;"
   ],
   [
    "li",
    "personalise the learning experience;"
   ],
   [
    "li",
    "provide subscription features;"
   ],
   [
    "li",
    "process payments;"
   ],
   [
    "li",
    "respond to questions or support requests;"
   ],
   [
    "li",
    "maintain the security of DeenLit;"
   ],
   [
    "li",
    "prevent fraud, misuse and unauthorised access;"
   ],
   [
    "li",
    "diagnose technical problems;"
   ],
   [
    "li",
    "understand how our service is being used;"
   ],
   [
    "li",
    "improve books, quizzes and features;"
   ],
   [
    "li",
    "send service-related communications."
   ],
   [
    "p",
    "We do not use children's personal information in ways that conflict with their best interests."
   ],
   [
    "h",
    "4. Children's Privacy"
   ],
   [
    "p",
    "Protecting children's privacy is particularly important to DeenLit."
   ],
   [
    "p",
    "We aim to collect only the information reasonably necessary for children to use the educational features of the service."
   ],
   [
    "p",
    "Where appropriate, child profiles are managed through a parent or guardian's account."
   ],
   [
    "p",
    "We aim to provide children with a high level of privacy by default."
   ],
   [
    "p",
    "We do not sell children's personal information."
   ],
   [
    "p",
    "We do not use children's personal information for behavioural or targeted advertising."
   ],
   [
    "p",
    "We do not intentionally encourage children to provide unnecessary personal information."
   ],
   [
    "h",
    "Children under 13"
   ],
   [
    "p",
    "Where DeenLit relies upon consent and the child is under 13, we may take reasonable steps to confirm parental responsibility where necessary."
   ],
   [
    "p",
    "Parents and guardians may contact us if they believe their child has provided personal information without appropriate permission."
   ],
   [
    "h",
    "5. Our Bases for Using Personal Information"
   ],
   [
    "p",
    "Depending on the circumstances, we may rely upon the following grounds."
   ],
   [
    "h",
    "Contract"
   ],
   [
    "p",
    "We may process information where it is necessary to provide DeenLit or a subscription that you have requested."
   ],
   [
    "p",
    "For example, we need certain information to create an account, maintain profiles and provide subscribed features."
   ],
   [
    "h",
    "Legitimate interests"
   ],
   [
    "p",
    "We may process information where necessary for legitimate interests such as:"
   ],
   [
    "li",
    "operating and improving DeenLit;"
   ],
   [
    "li",
    "maintaining security;"
   ],
   [
    "li",
    "preventing fraud and misuse;"
   ],
   [
    "li",
    "fixing technical problems;"
   ],
   [
    "li",
    "understanding the performance of our service; and"
   ],
   [
    "li",
    "protecting our rights."
   ],
   [
    "p",
    "Where children's information is involved, we give particular consideration to the child's rights, interests and wellbeing."
   ],
   [
    "h",
    "Consent"
   ],
   [
    "p",
    "We may ask for consent for certain optional activities, such as particular analytics technologies, marketing communications or other optional features."
   ],
   [
    "p",
    "Consent can be withdrawn where applicable."
   ],
   [
    "h",
    "Regulations and obligations"
   ],
   [
    "p",
    "We may process or retain information where necessary to comply with regulations, tax requirements, accounting requirements or other requests from authorities."
   ],
   [
    "h",
    "6. Cookies and Similar Technologies"
   ],
   [
    "p",
    "DeenLit may use cookies, local storage or similar technologies to operate its website or application."
   ],
   [
    "p",
    "These technologies may be used to:"
   ],
   [
    "li",
    "keep users signed in;"
   ],
   [
    "li",
    "remember settings and preferences;"
   ],
   [
    "li",
    "maintain security;"
   ],
   [
    "li",
    "remember progress;"
   ],
   [
    "li",
    "provide essential functionality;"
   ],
   [
    "li",
    "diagnose errors; and"
   ],
   [
    "li",
    "understand how DeenLit is being used."
   ],
   [
    "p",
    "Where consent is required for non-essential cookies or similar technologies, we will ask for permission before using them."
   ],
   [
    "p",
    "Users can withdraw or change their choices where applicable."
   ],
   [
    "p",
    "Further information may be provided in our Cookie Policy or cookie settings."
   ],
   [
    "h",
    "7. Analytics"
   ],
   [
    "p",
    "DeenLit may use privacy-conscious analytics or diagnostic services to understand how the platform performs and which features are being used."
   ],
   [
    "p",
    "Where analytics requires consent, it will not be activated until the necessary consent has been obtained."
   ],
   [
    "p",
    "We seek to minimise the amount of children's information used for analytics and do not use children's analytics data for targeted advertising."
   ],
   [
    "h",
    "8. Who We Share Information With"
   ],
   [
    "p",
    "We do not sell personal information."
   ],
   [
    "p",
    "We may share limited information with trusted companies that help us operate DeenLit, such as providers of:"
   ],
   [
    "li",
    "website and server hosting;"
   ],
   [
    "li",
    "cloud storage;"
   ],
   [
    "li",
    "authentication;"
   ],
   [
    "li",
    "email delivery;"
   ],
   [
    "li",
    "customer support;"
   ],
   [
    "li",
    "payment processing;"
   ],
   [
    "li",
    "analytics;"
   ],
   [
    "li",
    "error monitoring; and"
   ],
   [
    "li",
    "security services."
   ],
   [
    "p",
    "These companies should only receive information necessary to perform their services and must handle personal information appropriately."
   ],
   [
    "p",
    "We may also disclose information where reasonably necessary to:"
   ],
   [
    "li",
    "prevent fraud or serious misuse;"
   ],
   [
    "li",
    "protect the security of DeenLit;"
   ],
   [
    "li",
    "protect users from harm."
   ],
   [
    "p",
    "If the ownership or structure of DeenLit changes, relevant information may be transferred as part of a genuine business sale, merger or restructuring, subject to appropriate privacy protections."
   ],
   [
    "h",
    "9. International Data Transfers"
   ],
   [
    "p",
    "Some companies that provide technical services to DeenLit may process information outside the United Kingdom."
   ],
   [
    "p",
    "Where personal information is transferred internationally, we will take appropriate steps to ensure that it receives a level of protection required."
   ],
   [
    "p",
    "This may include using countries recognised as providing adequate protection or putting appropriate contractual safeguards in place."
   ],
   [
    "h",
    "10. How Long We Keep Information"
   ],
   [
    "p",
    "We do not keep personal information for longer than reasonably necessary."
   ],
   [
    "p",
    "How long information is retained depends on why it was collected."
   ],
   [
    "p",
    "For example:"
   ],
   [
    "li",
    "account and profile information may be retained while an account remains active;"
   ],
   [
    "li",
    "reading progress and quiz information may be retained while the relevant profile exists;"
   ],
   [
    "li",
    "support communications may be retained for a reasonable period after a query has been resolved;"
   ],
   [
    "li",
    "security logs may be retained for a limited period for security and fraud prevention; and"
   ],
   [
    "li",
    "payment, tax and accounting records may be retained for the period required."
   ],
   [
    "p",
    "When information is no longer required, we will delete, anonymise or securely dispose of it where reasonably possible."
   ],
   [
    "h",
    "11. Account and Profile Deletion"
   ],
   [
    "p",
    "Users may request deletion of their DeenLit account and associated personal information."
   ],
   [
    "p",
    "Parents or guardians may also request deletion of a child's profile and the personal information associated with that profile."
   ],
   [
    "p",
    "Some limited information may need to be retained where required by authorities, for fraud prevention, security, dispute resolution or financial record-keeping."
   ],
   [
    "p",
    "To request deletion, contact:"
   ],
   [
    "h",
    "support@deenlit.com"
   ],
   [
    "h",
    "12. Keeping Information Secure"
   ],
   [
    "p",
    "We use reasonable technical and organisational measures intended to protect personal information against:"
   ],
   [
    "li",
    "unauthorised access;"
   ],
   [
    "li",
    "accidental loss;"
   ],
   [
    "li",
    "alteration;"
   ],
   [
    "li",
    "disclosure; and"
   ],
   [
    "li",
    "destruction."
   ],
   [
    "p",
    "Measures may include encrypted connections, secure authentication, access controls, backups, server security and limiting access to information to those who require it."
   ],
   [
    "p",
    "No internet service can guarantee absolute security, but we work to maintain safeguards appropriate to the information we process."
   ],
   [
    "h",
    "13. Parents and Guardians"
   ],
   [
    "p",
    "Parents and guardians may contact us to:"
   ],
   [
    "li",
    "ask what information we hold about their child;"
   ],
   [
    "li",
    "correct inaccurate information;"
   ],
   [
    "li",
    "request deletion of a child's profile;"
   ],
   [
    "li",
    "raise a privacy concern;"
   ],
   [
    "li",
    "withdraw consent where processing is based on consent; or"
   ],
   [
    "li",
    "ask questions about how children's information is used."
   ],
   [
    "p",
    "We may need to verify the identity or parental responsibility of the person making the request before providing or deleting information."
   ],
   [
    "h",
    "14. Your Data Protection Rights"
   ],
   [
    "p",
    "Depending on the circumstances, your rights could include the right to:"
   ],
   [
    "li",
    "request access to your personal information;"
   ],
   [
    "li",
    "request correction of inaccurate information;"
   ],
   [
    "li",
    "request deletion of your information;"
   ],
   [
    "li",
    "request restriction of processing;"
   ],
   [
    "li",
    "object to certain processing;"
   ],
   [
    "li",
    "request transfer of certain information;"
   ],
   [
    "li",
    "withdraw consent where processing is based on consent; and"
   ],
   [
    "li",
    "make a complaint about the way your information has been handled."
   ],
   [
    "p",
    "Not every right applies in every circumstance."
   ],
   [
    "p",
    "To exercise a privacy right, contact:"
   ],
   [
    "h",
    "support@deenlit.com"
   ],
   [
    "p",
    "We may need to verify your identity before completing a request."
   ],
   [
    "h",
    "15. Advertising"
   ],
   [
    "p",
    "DeenLit does not sell personal information to advertisers."
   ],
   [
    "p",
    "DeenLit does not use children's personal information to create advertising profiles or deliver behaviourally targeted advertising to children."
   ],
   [
    "p",
    "If our approach to advertising changes in the future, this Privacy Policy will be updated and any consent required will be obtained before relevant tracking technologies are activated."
   ],
   [
    "h",
    "16. Third-Party Links"
   ],
   [
    "p",
    "Books, resources or other areas of DeenLit may occasionally contain links to third-party websites or services."
   ],
   [
    "p",
    "DeenLit is not responsible for the privacy practices of external websites. Parents and users should review the privacy information provided by those services before providing personal information to them."
   ],
   [
    "h",
    "17. Changes to This Privacy Policy"
   ],
   [
    "p",
    "We may update this Privacy Policy as DeenLit."
   ],
   [
    "p",
    "The latest version will be made available through DeenLit and the \"Last updated\" date at the top of this policy will be changed."
   ],
   [
    "p",
    "If a change significantly affects how we use personal information, we will provide appropriate notice where required."
   ],
   [
    "h",
    "18. Contact Us"
   ],
   [
    "p",
    "For privacy questions, requests or concerns, contact:"
   ],
   [
    "p",
    "DeenLit\nLegal entity: StreamBooks Ltd\nEmail: support@deenlit.com\nAddress:14/2E Docklands Business Centre\n10–16 Tiller Road\nLondon\nE14 8PX\nUnited Kingdom"
   ],
   [
    "p",
    "For general enquiries:"
   ],
   [
    "h",
    "support@deenlit.com"
   ]
  ]
 },
 "terms": {
  "title": "Terms and Conditions",
  "updated": "30 September 2026",
  "blocks": [
   [
    "p",
    "Welcome to DeenLit."
   ],
   [
    "p",
    "These Terms and Conditions (\"Terms\") govern your access to and use of the DeenLit website, application, books, quizzes, audio, educational materials and related services (together, the \"Service\")."
   ],
   [
    "p",
    "Please read these Terms carefully before using DeenLit."
   ],
   [
    "p",
    "By creating an account, starting a free trial, purchasing a subscription or otherwise using DeenLit, you agree to these Terms."
   ],
   [
    "p",
    "If you are creating an account or subscription for a child, you confirm that you are the child's parent, guardian or another adult authorised to provide access to the Service."
   ],
   [
    "h",
    "1. About DeenLit"
   ],
   [
    "p",
    "DeenLit is an educational platform providing digital reading materials, educational books, quizzes, audio and other learning resources for children and families."
   ],
   [
    "p",
    "DeenLit is operated by:"
   ],
   [
    "p",
    "DeenLit\nLegal entity: StreamBooks Ltd14/2E Docklands Business Centre\n10–16 Tiller Road\nLondon\nE14 8PX\nUnited Kingdom"
   ],
   [
    "p",
    "Email: support@deenlit.com"
   ],
   [
    "p",
    "References in these Terms to \"DeenLit\", \"we\", \"us\" or \"our\" mean the person or business operating DeenLit."
   ],
   [
    "h",
    "2. Who May Use DeenLit"
   ],
   [
    "p",
    "DeenLit is intended for children and families."
   ],
   [
    "p",
    "A child may use DeenLit through an account or profile that has been created or authorised by a parent or guardian where required."
   ],
   [
    "p",
    "Purchases and paid subscriptions must be made by an adult who has the capacity to enter into the agreement."
   ],
   [
    "p",
    "Children should not independently provide payment information or purchase subscriptions."
   ],
   [
    "p",
    "Parents and guardians are responsible for supervising their child's use of DeenLit where appropriate."
   ],
   [
    "h",
    "3. Parent and Child Profiles"
   ],
   [
    "p",
    "A parent or guardian may be able to create separate profiles for children using their DeenLit account."
   ],
   [
    "p",
    "Profiles may contain features such as:"
   ],
   [
    "li",
    "reading progress;"
   ],
   [
    "li",
    "books read or currently being read;"
   ],
   [
    "li",
    "favourites;"
   ],
   [
    "li",
    "playlists;"
   ],
   [
    "li",
    "quiz results;"
   ],
   [
    "li",
    "achievements;"
   ],
   [
    "li",
    "Noor Points;"
   ],
   [
    "li",
    "language preferences; and"
   ],
   [
    "li",
    "other learning information."
   ],
   [
    "p",
    "The parent or guardian who controls the main account is responsible for managing access to child profiles."
   ],
   [
    "p",
    "You should not include unnecessary personal information about a child in a profile name or elsewhere on DeenLit."
   ],
   [
    "h",
    "4. Creating an Account"
   ],
   [
    "p",
    "Some DeenLit features may require an account."
   ],
   [
    "p",
    "When creating an account, you agree to provide accurate information and keep relevant account information up to date."
   ],
   [
    "p",
    "You are responsible for:"
   ],
   [
    "li",
    "keeping your login details secure;"
   ],
   [
    "li",
    "protecting your password;"
   ],
   [
    "li",
    "controlling access to your account;"
   ],
   [
    "li",
    "informing us if you believe your account has been accessed without permission; and"
   ],
   [
    "li",
    "activities carried out through your account where reasonably within your control."
   ],
   [
    "p",
    "You must not share your password publicly or attempt to access another user's account."
   ],
   [
    "p",
    "Contact support@deenlit.com if you believe your account has been compromised."
   ],
   [
    "h",
    "5. Using DeenLit"
   ],
   [
    "p",
    "DeenLit grants you a limited, personal, non-exclusive, non-transferable and revocable right to access and use the Service in accordance with these Terms."
   ],
   [
    "p",
    "Unless we expressly give permission otherwise, DeenLit content is for personal and educational use only."
   ],
   [
    "p",
    "Purchasing a subscription gives you access to the relevant content. It does not transfer ownership of that content to you."
   ],
   [
    "h",
    "6. Educational Content"
   ],
   [
    "p",
    "DeenLit aims to provide high-quality educational material."
   ],
   [
    "p",
    "However, educational materials may occasionally contain mistakes, omissions or information that later requires correction."
   ],
   [
    "p",
    "We may revise, correct or update educational content where appropriate."
   ],
   [
    "p",
    "Reading levels, quiz scores, achievements and similar features are intended as learning tools. They should not be treated as official academic assessments, qualifications or guarantees of a child's educational ability or progress."
   ],
   [
    "p",
    "Parents, teachers and guardians should use their own judgement when deciding whether particular material is suitable for a child."
   ],
   [
    "h",
    "7. Islamic and Religious Content"
   ],
   [
    "p",
    "DeenLit may contain educational material relating to Islam, including Islamic history, Qur'anic material, hadith, Islamic values and other religious subjects."
   ],
   [
    "p",
    "We make reasonable efforts to provide accurate material and appropriate sources where relevant."
   ],
   [
    "p",
    "However, DeenLit is an educational resource and is not a substitute for personalised religious rulings or scholarly advice."
   ],
   [
    "p",
    "Where a user needs a specific religious ruling, particularly concerning individual circumstances, they should consult an appropriately qualified and trusted scholar."
   ],
   [
    "p",
    "Differences of legitimate scholarly opinion may exist on some matters."
   ],
   [
    "h",
    "8. Subscriptions"
   ],
   [
    "p",
    "DeenLit may offer free and paid access."
   ],
   [
    "p",
    "Details of any paid subscription, including:"
   ],
   [
    "li",
    "price;"
   ],
   [
    "li",
    "billing period;"
   ],
   [
    "li",
    "features included;"
   ],
   [
    "li",
    "whether the subscription renews automatically;"
   ],
   [
    "li",
    "any free trial; and"
   ],
   [
    "li",
    "how to cancel"
   ],
   [
    "p",
    "will be shown before the subscription is purchased."
   ],
   [
    "p",
    "If a subscription automatically renews, this will be made clear before purchase."
   ],
   [
    "p",
    "Unless otherwise stated during purchase, an automatically renewing subscription will continue for successive billing periods until cancelled."
   ],
   [
    "p",
    "You may cancel an automatically renewing subscription in accordance with the cancellation instructions provided through DeenLit."
   ],
   [
    "p",
    "Cancellation normally prevents future renewal. Access may continue until the end of the period already paid for or the particular subscription terms provide otherwise."
   ],
   [
    "h",
    "9. Prices and Payment"
   ],
   [
    "p",
    "Subscription prices will be displayed before you complete a purchase."
   ],
   [
    "p",
    "Prices will state whether applicable taxes are included where required."
   ],
   [
    "p",
    "Payments may be processed by a third-party payment provider."
   ],
   [
    "p",
    "By purchasing a subscription or starting a free trial that converts into a paid subscription, you confirm that:"
   ],
   [
    "li",
    "you are authorised to use the chosen payment method;"
   ],
   [
    "li",
    "the payment information provided is accurate; and"
   ],
   [
    "li",
    "you authorise the relevant payment to be taken when payment becomes due."
   ],
   [
    "p",
    "We may change prices in the future."
   ],
   [
    "p",
    "A price change will not retrospectively change the price of a period that has already been paid for."
   ],
   [
    "p",
    "For recurring subscriptions, we will provide any notice required by before relevant price changes take effect."
   ],
   [
    "h",
    "10. 7-Day Free Trial"
   ],
   [
    "p",
    "DeenLit may offer eligible users a 7-day free trial."
   ],
   [
    "p",
    "When you start a free trial, you will be shown the price and billing frequency of the subscription that will begin after the trial ends."
   ],
   [
    "p",
    "Unless you cancel, your free trial will automatically convert into a paid subscription at the end of the 7-day trial period."
   ],
   [
    "p",
    "The payment method you provided will then be charged the applicable subscription fee."
   ],
   [
    "h",
    "Cancelling your free trial"
   ],
   [
    "p",
    "If you do not want to be charged, you must cancel your subscription before the 7-day free trial ends."
   ],
   [
    "p",
    "You may cancel at any time during the trial period."
   ],
   [
    "p",
    "If you cancel before the free trial expires, you will not be charged for the next subscription period."
   ],
   [
    "p",
    "Depending on how you subscribed, cancellation may need to be completed:"
   ],
   [
    "li",
    "through your DeenLit account; or"
   ],
   [
    "li",
    "through the relevant app store, payment provider or third-party platform."
   ],
   [
    "p",
    "Simply deleting the DeenLit app, deleting a child profile, logging out, or stopping use of DeenLit does not cancel your subscription."
   ],
   [
    "p",
    "You must complete the cancellation process before the free trial ends if you do not wish to continue with a paid subscription."
   ],
   [
    "p",
    "We will clearly display the subscription price, billing frequency and automatic renewal terms before you start the free trial."
   ],
   [
    "p",
    "After the free trial ends, your paid subscription will begin and will continue to renew according to your chosen subscription plan until cancelled."
   ],
   [
    "h",
    "11. Promotional Offers"
   ],
   [
    "p",
    "From time to time, DeenLit may offer discounts or promotional access."
   ],
   [
    "p",
    "Additional conditions may apply to a particular promotion and will be displayed when the offer is made."
   ],
   [
    "p",
    "Users must not create multiple accounts or otherwise misuse promotional offers or free trials in order to obtain benefits they are not entitled to receive."
   ],
   [
    "p",
    "We may refuse or withdraw promotional access where we reasonably believe a promotion has been abused."
   ],
   [
    "h",
    "12. Cancellation of Paid Subscriptions"
   ],
   [
    "p",
    "You may cancel an automatically renewing paid subscription at any time."
   ],
   [
    "p",
    "Once cancelled, your subscription will not renew at the end of the current billing period."
   ],
   [
    "p",
    "Unless otherwise stated, you may continue using the paid features until the end of the period you have already paid for."
   ],
   [
    "p",
    "To cancel a DeenLit subscription, use:"
   ],
   [
    "h",
    "Account → Subscription → Cancel"
   ],
   [
    "p",
    "or contact:"
   ],
   [
    "h",
    "support@deenlit.com"
   ],
   [
    "p",
    "If your subscription was purchased through an app store or another third-party provider, you may need to cancel through that provider."
   ],
   [
    "p",
    "Deleting the DeenLit application or your account does not necessarily cancel a subscription managed by a third-party provider."
   ],
   [
    "h",
    "13. Refunds"
   ],
   [
    "p",
    "Refunds will be provided where required."
   ],
   [
    "p",
    "Additional refunds may be offered at our discretion where appropriate."
   ],
   [
    "p",
    "Your statutory rights are not affected by this section."
   ],
   [
    "p",
    "If you believe you have been charged incorrectly, contact:"
   ],
   [
    "h",
    "support@deenlit.com"
   ],
   [
    "p",
    "and provide sufficient information for us to investigate the payment."
   ],
   [
    "h",
    "14. Acceptable Use"
   ],
   [
    "p",
    "You must not:"
   ],
   [
    "li",
    "attempt to gain unauthorised access to DeenLit or another user's account;"
   ],
   [
    "li",
    "interfere with the operation or security of the Service;"
   ],
   [
    "li",
    "introduce viruses, malware or harmful code;"
   ],
   [
    "li",
    "attempt to bypass security measures;"
   ],
   [
    "li",
    "scrape or systematically extract DeenLit content without permission;"
   ],
   [
    "li",
    "use automated systems to copy substantial amounts of DeenLit content;"
   ],
   [
    "li",
    "reproduce or distribute our books without permission;"
   ],
   [
    "li",
    "impersonate another person;"
   ],
   [
    "li",
    "use DeenLit for fraudulent purposes;"
   ],
   [
    "li",
    "attempt to manipulate quizzes, achievements or reward systems dishonestly;"
   ],
   [
    "li",
    "reverse engineer software except where expressly permitted;"
   ],
   [
    "li",
    "use DeenLit in a way that infringes another person's rights."
   ],
   [
    "p",
    "We may restrict access where we reasonably believe these rules have been seriously or repeatedly breached."
   ],
   [
    "h",
    "15. Intellectual Property"
   ],
   [
    "p",
    "Unless otherwise stated, the DeenLit platform and its original content are owned by or licensed to DeenLit."
   ],
   [
    "p",
    "This may include:"
   ],
   [
    "li",
    "books;"
   ],
   [
    "li",
    "stories;"
   ],
   [
    "li",
    "illustrations;"
   ],
   [
    "li",
    "cover artwork;"
   ],
   [
    "li",
    "quizzes;"
   ],
   [
    "li",
    "questions;"
   ],
   [
    "li",
    "translations;"
   ],
   [
    "li",
    "audio recordings;"
   ],
   [
    "li",
    "narration;"
   ],
   [
    "li",
    "logos;"
   ],
   [
    "li",
    "branding;"
   ],
   [
    "li",
    "page designs;"
   ],
   [
    "li",
    "graphics;"
   ],
   [
    "li",
    "software;"
   ],
   [
    "li",
    "databases;"
   ],
   [
    "li",
    "educational resources; and"
   ],
   [
    "li",
    "other original material."
   ],
   [
    "p",
    "These materials may be protected by copyright or trade mark."
   ],
   [
    "h",
    "What you may do"
   ],
   [
    "p",
    "You may access and use DeenLit content for normal personal and educational use permitted by your account or subscription."
   ],
   [
    "h",
    "What you may not do"
   ],
   [
    "p",
    "Unless you have our written permission, you must not:"
   ],
   [
    "li",
    "republish our books;"
   ],
   [
    "li",
    "upload our books to another website or service;"
   ],
   [
    "li",
    "distribute copies of our content;"
   ],
   [
    "li",
    "sell our content;"
   ],
   [
    "li",
    "remove copyright or ownership notices;"
   ],
   [
    "li",
    "reproduce substantial parts of our library;"
   ],
   [
    "li",
    "create unauthorised commercial products using our content; or"
   ],
   [
    "li",
    "present DeenLit content as your own work."
   ],
   [
    "h",
    "16. Screenshots, Printing and Classroom Use"
   ],
   [
    "p",
    "Teachers may use reasonable portions of DeenLit materials within their own teaching where permitted by their subscription and applicable."
   ],
   [
    "p",
    "A DeenLit subscription does not automatically grant permission to reproduce or distribute entire books to a class, school, website, social media account or third party unless the relevant subscription specifically allows this."
   ],
   [
    "p",
    "Separate school or institutional licensing terms may apply where offered."
   ],
   [
    "h",
    "17. User Feedback"
   ],
   [
    "p",
    "If you voluntarily send us suggestions, corrections, ideas or feedback about DeenLit, you allow us to use that feedback to improve our Service."
   ],
   [
    "p",
    "Providing feedback does not automatically give you ownership of changes or features that DeenLit later develops."
   ],
   [
    "h",
    "18. Service Availability"
   ],
   [
    "p",
    "We aim to keep DeenLit available and functioning reliably."
   ],
   [
    "p",
    "However, we cannot guarantee that the Service will always operate without interruption."
   ],
   [
    "p",
    "Access may occasionally be unavailable because of:"
   ],
   [
    "li",
    "maintenance;"
   ],
   [
    "li",
    "updates;"
   ],
   [
    "li",
    "technical faults;"
   ],
   [
    "li",
    "security incidents;"
   ],
   [
    "li",
    "internet or hosting problems;"
   ],
   [
    "li",
    "circumstances outside our reasonable control; or"
   ],
   [
    "li",
    "changes necessary to maintain or improve the Service."
   ],
   [
    "p",
    "Where reasonably possible, we will try to minimise significant disruption."
   ],
   [
    "h",
    "19. Changes to DeenLit"
   ],
   [
    "p",
    "DeenLit is an evolving educational service."
   ],
   [
    "p",
    "We may add, remove, update or modify features and content."
   ],
   [
    "p",
    "We will not make changes to a paid service in a way that unfairly removes material benefits a consumer has already paid for."
   ],
   [
    "p",
    "If a significant change materially disadvantages an existing paid subscriber, we will provide an appropriate remedy where required."
   ],
   [
    "h",
    "20. Updates to Books and Educational Materials"
   ],
   [
    "p",
    "We may update books, quizzes, translations or other materials to:"
   ],
   [
    "li",
    "correct errors;"
   ],
   [
    "li",
    "improve clarity;"
   ],
   [
    "li",
    "update information;"
   ],
   [
    "li",
    "improve age suitability;"
   ],
   [
    "li",
    "improve accessibility;"
   ],
   [
    "li",
    "address technical issues; or"
   ],
   [
    "li",
    "improve educational quality."
   ],
   [
    "p",
    "A book or quiz may therefore change after it has first been published on DeenLit."
   ],
   [
    "h",
    "21. Third-Party Services"
   ],
   [
    "p",
    "DeenLit may use or link to third-party services."
   ],
   [
    "p",
    "Examples may include payment providers, app stores or external websites."
   ],
   [
    "p",
    "Third-party services may have their own terms and privacy policies."
   ],
   [
    "p",
    "We are not responsible for the content or operation of an independent third-party website merely because DeenLit provides a link to it."
   ],
   [
    "h",
    "22. Suspension of Accounts"
   ],
   [
    "p",
    "We may temporarily restrict or suspend an account where reasonably necessary because:"
   ],
   [
    "li",
    "the account's security may have been compromised;"
   ],
   [
    "li",
    "fraudulent activity is suspected;"
   ],
   [
    "li",
    "payment has failed;"
   ],
   [
    "li",
    "these Terms have been seriously or repeatedly breached;"
   ],
   [
    "li",
    "continued access creates a security risk;"
   ],
   [
    "li",
    "continued access may cause harm to DeenLit or other users; or"
   ],
   [
    "li",
    "when authority requires us to do so."
   ],
   [
    "p",
    "Where appropriate and reasonably possible, we will explain the reason for the restriction."
   ],
   [
    "p",
    "We will not unfairly remove paid access without considering the consumer's contractual and statutory rights."
   ],
   [
    "h",
    "23. Closing Your Account"
   ],
   [
    "p",
    "You may stop using DeenLit at any time."
   ],
   [
    "p",
    "You may request deletion of your account in accordance with our Privacy Policy."
   ],
   [
    "p",
    "Deleting an account and cancelling a paid subscription may be separate actions, particularly where payment is managed through a third-party app store."
   ],
   [
    "p",
    "You should therefore make sure any recurring subscription has also been cancelled."
   ],
   [
    "h",
    "24. Our Responsibility to You"
   ],
   [
    "p",
    "We are responsible for losses that are a foreseeable result of our breach of these Terms or our failure to use reasonable care and skill."
   ],
   [
    "p",
    "We are not responsible for losses that were not reasonably foreseeable when the agreement was entered into."
   ],
   [
    "p",
    "DeenLit is intended primarily for private, educational and domestic use."
   ],
   [
    "p",
    "We are not responsible for business losses such as loss of profits, revenue, business opportunity or commercial reputation arising from personal consumer use of DeenLit."
   ],
   [
    "h",
    "25. Parental Responsibility"
   ],
   [
    "p",
    "Parents and guardians remain responsible for deciding whether particular DeenLit material is appropriate for their child."
   ],
   [
    "p",
    "Although we aim to make content suitable for its intended audience, children's abilities, sensitivities and educational needs vary."
   ],
   [
    "p",
    "Parents and guardians should supervise children's internet and device use as they consider appropriate."
   ],
   [
    "h",
    "26. Privacy"
   ],
   [
    "p",
    "Your privacy is important to us."
   ],
   [
    "p",
    "Our Privacy Policy explains what personal information we collect, how we use it and the rights available to users and parents."
   ],
   [
    "p",
    "The Privacy Policy should be read alongside these Terms."
   ],
   [
    "h",
    "27. Changes to These Terms"
   ],
   [
    "p",
    "We may update these Terms where reasonably necessary, including because of:"
   ],
   [
    "li",
    "changes to DeenLit;"
   ],
   [
    "li",
    "new features;"
   ],
   [
    "li",
    "security requirements; or"
   ],
   [
    "li",
    "changes to our business."
   ],
   [
    "p",
    "The latest version will be published on DeenLit with the date it was last updated."
   ],
   [
    "p",
    "Where a significant change materially affects existing subscribers, we will provide appropriate notice."
   ],
   [
    "p",
    "Changes will not remove statutory rights."
   ],
   [
    "h",
    "28. Complaints"
   ],
   [
    "p",
    "If you have a problem with DeenLit, please contact us so that we can try to resolve it."
   ],
   [
    "p",
    "Email: support@deenlit.com"
   ],
   [
    "p",
    "Please provide enough information for us to identify the issue and the relevant account or transaction."
   ],
   [
    "h",
    "29. No Waiver"
   ],
   [
    "p",
    "If we do not immediately enforce a provision of these Terms, this does not mean that we have permanently given up the right to enforce it."
   ],
   [
    "h",
    "30. Transfer of This Agreement"
   ],
   [
    "p",
    "You may not transfer your DeenLit account or your rights under these Terms to another person without our permission."
   ],
   [
    "p",
    "We may transfer our rights and obligations to another organisation where permitted, for example as part of a sale or restructuring of DeenLit."
   ],
   [
    "p",
    "Any transfer will not reduce your statutory consumer rights."
   ],
   [
    "h",
    "31. Contact DeenLit"
   ],
   [
    "p",
    "Questions about these Terms can be sent to:"
   ],
   [
    "p",
    "DeenLit\nStreamBooks Ltd14/2E Docklands Business Centre\n10–16 Tiller Road\nLondon\nE14 8PX\nUnited Kingdom"
   ],
   [
    "p",
    "Email: support@deenlit.com"
   ],
   [
    "p",
    "For account or subscription support:"
   ],
   [
    "h",
    "support@deenlit.com"
   ],
   [
    "p",
    "For privacy matters:"
   ],
   [
    "h",
    "support@deenlit.com"
   ]
  ]
 }
};
